import { Modal } from "@unified-checkout/design-system";
import { MOBILE_BREAKPOINT } from "@app/dashboard/constants/break-points";
import { useScreenWidth } from "@app/dashboard/hooks/useScreenWidth";
import type {
  IConfirmationModal
} from "@app/dashboard/types/innerLayout/user_management/modals/confirmation-modal";
import styles from "./confirmation-modal.module.scss";

export const ConfirmationModal = ({
  modalProps
}: IConfirmationModal) => {
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= MOBILE_BREAKPOINT;

  return (
    <div className={styles["confirmation-modal"]}>
      <Modal
        {...modalProps}
        isMobile={isMobile}
        closeOnClickOutside={false}
      />
    </div>
  )
}